import { LEGAL_OVERTIME_RATE_36_TO_43_PERCENT, LEGAL_OVERTIME_RATE_ABOVE_43_PERCENT } from "./remuneration.constants";

export type StructuredOvertimeLabelSource = {
  rtt_enabled: boolean;
  rtt_weekly_hours?: number | null;
  overtime_enabled: boolean;
  overtime_has_custom_convention?: boolean | null;
  overtime_rate_36_to_43_percent?: number | null;
  overtime_rate_above_43_percent?: number | null;
  overtime_weekly_hours?: number | null;
};

const frenchHoursFormatter = new Intl.NumberFormat("fr-FR", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const formatRttPart = (profile: StructuredOvertimeLabelSource): string => {
  if (!profile.rtt_enabled) {
    return "RTT : non";
  }

  if (profile.rtt_weekly_hours == null) {
    return "RTT : oui";
  }

  return `RTT : oui (${frenchHoursFormatter.format(profile.rtt_weekly_hours)} h/sem)`;
};

const formatOvertimeHoursPrefix = (hours: number | null | undefined): string => {
  if (typeof hours !== "number" || hours <= 0) return "";
  return `${frenchHoursFormatter.format(hours)} h/sem, `;
};

const formatOvertimePart = (profile: StructuredOvertimeLabelSource): string => {
  if (!profile.overtime_enabled) {
    return "HS à la demande du client : non";
  }

  const hoursPrefix = formatOvertimeHoursPrefix(profile.overtime_weekly_hours);

  if (profile.overtime_has_custom_convention === true) {
    const rate36To43 = profile.overtime_rate_36_to_43_percent;
    const rateAbove43 = profile.overtime_rate_above_43_percent;
    if (rate36To43 != null && rateAbove43 != null) {
      return `HS à la demande du client : oui (${hoursPrefix}convention spécifique ${frenchHoursFormatter.format(rate36To43)} % / ${frenchHoursFormatter.format(rateAbove43)} %)`;
    }

    return `HS à la demande du client : oui (${hoursPrefix}convention spécifique)`;
  }

  return `HS à la demande du client : oui (${hoursPrefix}taux légaux ${LEGAL_OVERTIME_RATE_36_TO_43_PERCENT} % / ${LEGAL_OVERTIME_RATE_ABOVE_43_PERCENT} %)`;
};

/** Formats structured RTT / overtime flags into the legacy `contract.overtime` textarea. */
export const formatStructuredOvertimeLabel = (profile: StructuredOvertimeLabelSource): string =>
  `${formatRttPart(profile)} ; ${formatOvertimePart(profile)}`;
